export default () => ({
  tabs: {
    width: '100%',
    maxWidth: '1292px',
  },
  tab: {
    flexShrink: 0,
  },
});
